// Angular
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Subscription } from 'rxjs';
// Layout
import { SubheaderService, MachineService } from '../../../../../core/_base/layout';
import { Breadcrumb } from '../../../../../core/_base/layout/services/subheader.service';

import { Cache } from 'aws-amplify';
import { Router, NavigationStart } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
	selector: 'kt-subheader1',
	templateUrl: './subheader1.component.html',
	styleUrls: ['./subheader1.component.scss']
})
export class Subheader1Component implements OnInit, OnDestroy, AfterViewInit {
	// Public properties
	@Input() fluid: boolean;
	@Input() clear: boolean;

	today: number = Date.now();
	title = '';
	desc = '';
	breadcrumbs: Breadcrumb[] = [];
	machine;
	role: string;

	// Private properties
	private subscriptions: Subscription[] = [];

	/**
	 * Component constructor
	 *
	 * @param subheaderService: SubheaderService
	 */
	constructor(public subheaderService: SubheaderService, private machineService: MachineService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private _snackBar: MatSnackBar) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		const user = Cache.getItem('userAttr');
		this.role = user ? user['custom:role'] : '';

		this.machine = Cache.getItem('selected_machine');

		this.router.events.subscribe((value: any) => {
			if (value instanceof NavigationStart) {
				if (value.url.startsWith('/machine/')) {
					if (this.machine) {
						this.desc = (!this.machine.machine_name)?'UN-NAMED':this.machine.machine_name + " | " + (this.machine.machine_id_display || this.machine.machine_id);
					}
				} else {
					this.desc = '';
				}
				this.cdr.detectChanges();
			  }
		});
	}

	/**
	 * After view init
	 */
	ngAfterViewInit(): void {

		const currUrl = this.router.url;
		if (currUrl.startsWith('/machine/')) {
			if (this.machine) {
				this.desc = (!this.machine.machine_name)?'UN-NAMED':this.machine.machine_name + " | " + (this.machine.machine_id_display || this.machine.machine_id);
			}
		} else {
			this.desc = '';
		}
		this.cdr.detectChanges();

		this.machineService.selectedMachine$.subscribe(mId => {
			this.machine = mId;
			this.desc = (!this.machine.machine_name)?'UN-NAMED':this.machine.machine_name + " | " + (this.machine.machine_id_display || this.machine.machine_id);
			this.cdr.detectChanges();
		});

		this.subscriptions.push(this.subheaderService.title$.subscribe(bt => {
			// breadcrumbs title sometimes can be undefined
			if (bt) {
				Promise.resolve(null).then(() => {
					this.title = bt.title;
					// this.desc = bt.desc;
				});
			}
		}));

		this.subscriptions.push(this.subheaderService.breadcrumbs$.subscribe(bc => {
			Promise.resolve(null).then(() => {
				this.breadcrumbs = bc;
			});
		}));
	}

	copyMachineInfo(): void {
		if (!this.machine || !this.machine.machine_id) {
			return;
		}

		const machineId = this.machine.machine_id;

		// Use the Clipboard API
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(machineId).then(() => {
				this.showSnackBar(`Machine ID "${machineId}" copied to clipboard`, 2000);
			}).catch(() => {
				// Fallback for older browsers
				this.fallbackCopyToClipboard(machineId);
			});
		} else {
			// Fallback for browsers that don't support Clipboard API
			this.fallbackCopyToClipboard(machineId);
		}
	}

	private fallbackCopyToClipboard(text: string): void {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.left = '-999999px';
		textArea.style.top = '-999999px';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			document.execCommand('copy');
			this.showSnackBar(`Machine ID "${text}" copied to clipboard`, 2000);
		} catch (err) {
			this.showSnackBar('Failed to copy Machine ID', 2000);
		}

		document.body.removeChild(textArea);
	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}
}
